import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { Observable } from 'rxjs';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  constructor(private translocoLocaleService: TranslocoLocaleService) {}

  static getProvider(): Provider {
    return {
      provide: HTTP_INTERCEPTORS,
      useClass: LocaleInterceptor,
      multi: true
    };
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request.clone({ setHeaders: { 'Accept-Language': this.translocoLocaleService.getLocale() } }));
  }
}
